<template>
  <div>
    <div class="banner">
      <div class="headerReplacementBasicInfo"></div>
      <div class="banner-text">
        <b>{{ $t('listShareholderMajor.pageTitle') }}</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">{{ $t('listShareholderMajor.breadcrumbHome') }}</router-link></span>
          <span class="separator"></span>
          <span>{{ $t('listShareholderMajor.breadcrumbShareholder') }}</span>
          <span class="separator"></span>
          <span><b>{{ $t('listShareholderMajor.pageTitle') }}</b></span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="TabMenu">
        <BasicInfoTabMenu />
      </div>

      <div class="text-center mt-5">
        <h2>{{ $t('listShareholderMajor.chartTitle') }}</h2>
      </div>
      <div class="text-center mb-3">{{ $t('listShareholderMajor.chartAsOf') }}</div>

      <div class="row">
        <div class="col-md-8">
          <div class="text-center">
            <div ref="donutChart" class="donut-chart-container"></div>
          </div>
        </div>
        <div class="col-md-auto">
          <ul class="shareholder-list mt-5">
            <li v-for="shareholder in chartData" :key="shareholder.name">
              <span class="color-circle" :style="{ backgroundColor: shareholder.color }"></span>
              <span>{{ shareholder.name }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="mt-3 mb-3">{{ $t('listShareholderMajor.tableAsOf') }}</div>

      <table class="table mb-5">
        <thead>
          <tr class="table-secondary">
            <th class="col">{{ $t('listShareholderMajor.tableHeaderRank') }}</th>
            <th class="col">{{ $t('listShareholderMajor.tableHeaderName') }}</th>
            <th class="col text-end">{{ $t('listShareholderMajor.tableHeaderShares') }}</th>
            <th class="col text-end">{{ $t('listShareholderMajor.tableHeaderPercentage') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(shareholder, index) in tableData" :key="shareholder.name">
            <td v-if="index < 10">{{ index + 1 }}.</td>
            <td v-else></td>
            <td>{{ shareholder.name }}</td>
            <td class="text-end">{{ shareholder.shares.toLocaleString() }}</td>
            <td class="text-end">{{ shareholder.percentage.toFixed(2) }}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';
import Highcharts from 'highcharts';

export default {
  name: 'MajorShareholders',
  components: {
    BasicInfoTabMenu,
  },
  data() {
    return {
      shareholderDataTh: [
        { name: 'นาย พีระพงศ์ จรูญเอก', y: 29.68, percentage: 29.68, color: '#333333', shares: 728260954 },
        { name: 'บริษัท ทุนพีรดา จำกัด', y: 25.21, percentage: 25.21, color: '#E87D2E', shares: 618779918 },
        { name: 'นาง อารดา จรูญเอก', y: 10.68, percentage: 10.68, color: '#F4BB92', shares: 262036456 },
        { name: 'นาย สมพงษ์ ชลคดีดำรงกุล', y: 2.52, percentage: 2.52, color: '#C4C4C4', shares: 61787700 },
        { name: 'บริษัท ไทยเอ็นวีดีอาร์ จำกัด', y: 1.73, percentage: 1.73, color: '#636363', shares: 42573656 },
        { name: 'อื่นๆ', y: 30.18, percentage: 30.18, color: '#000000', shares: 3194806222 },
      ],

      shareholderDataEn: [
        { name: 'Mr. Peerapong Jaroon-ek', y: 29.68, percentage: 29.68, color: '#333333', shares: 728260954 },
        { name: 'Peerada Capital Company Limited', y: 25.21, percentage: 25.21, color: '#E87D2E', shares: 618779918 },
        { name: 'Mrs. Arada Jaroon-ek', y: 10.68, percentage: 10.68, color: '#F4BB92', shares: 262036456 },
        { name: 'Mr. Sompong Chonecadeedumrongkul', y: 2.52, percentage: 2.52, color: '#C4C4C4', shares: 61787700 },
        { name: 'Thai NVDR Company Limited', y: 1.73, percentage: 1.73, color: '#636363', shares: 42573656 },
        { name: 'Others', y: 30.18, percentage: 30.18, color: '#000000', shares: 3194806222 },
      ],

      shareholderTableTh: [
        { name: 'นาย พีระพงศ์ จรูญเอก', y: 29.68, percentage: 29.68, color: '#333333', shares: 728260954 },
        { name: 'บริษัท ทุนพีรดา จำกัด', y: 25.21, percentage: 25.21, color: '#E87D2E', shares: 618779918 },
        { name: 'นาง อารดา จรูญเอก', y: 10.68, percentage: 10.68, color: '#F4BB92', shares: 262036456 },
        { name: 'นาย สมพงษ์ ชลคดีดำรงกุล', y: 2.52, percentage: 2.52, color: '#C4C4C4', shares: 61787700 },
        { name: 'บริษัท ไทยเอ็นวีดีอาร์ จำกัด', y: 1.73, percentage: 1.73, color: '#636363', shares: 42573656 },
        { name: 'นาง วารุณี ชลคดีดำรงกุล', y: 0.89, percentage: 0.89, color: '#989898', shares: 21743000 },
        { name: 'นาย ศักดิ์ชัย ศักดิ์ชัยเจริญกุล', y: 0.75, percentage: 0.75, color: '#FFB6C1', shares: 18400000 },
        { name: 'นาย นิวัติ อาสาสุวรรณ', y: 0.59, percentage: 0.59, color: '#FFD700', shares: 14538400 },
        { name: 'น.ส. กิ่งแก้ว จรูญเอก', y: 0.30, percentage: 0.30, color: '#DAA520', shares: 7398923 },
        { name: 'นาย วัฒนะ เฮงเกียรติศักดิ์', y: 0.23, percentage: 0.23, color: '#BA55D3', shares: 5568300 },
        { name: 'ผู้ถือหุ้นอื่น', y: 27.42, percentage: 27.42, color: '#8A2BE2', shares: 673035146 },
        { name: 'จำนวนหุ้นทั้งหมด', y: 100.00, percentage: 100.00, color: '#000000', shares: 2454122453 }
      ],

      shareholderTableEn: [
        { name: 'Mr. Peerapong Jaroon-ek', y: 29.68, percentage: 29.68, color: '#333333', shares: 728260954 },
        { name: 'Peerada Capital Company Limited', y: 25.21, percentage: 25.21, color: '#E87D2E', shares: 618779918 },
        { name: 'Mrs. Arada Jaroon-ek', y: 10.68, percentage: 10.68, color: '#F4BB92', shares: 262036456 },
        { name: 'Mr. Sompong Chonecadeedumrongkul', y: 2.52, percentage: 2.52, color: '#C4C4C4', shares: 61787700 },
        { name: 'Thai NVDR Company Limited', y: 1.73, percentage: 1.73, color: '#636363', shares: 42573656 },
        { name: 'Mrs. Warunee Chonecadeedumrongkul', y: 0.89, percentage: 0.89, color: '#989898', shares: 21743000 },
        { name: 'Mr. Sakchai Sakchaicharoenkul', y: 0.75, percentage: 0.75, color: '#FFB6C1', shares: 18400000 },
        { name: 'Mr. Niwat Arsasuwan', y: 0.59, percentage: 0.59, color: '#FFD700', shares: 14538400 },
        { name: 'Miss Kingkaew Jaroon Ek', y: 0.30, percentage: 0.30, color: '#DAA520', shares: 7398923 },
        { name: 'Mr. Wattana Hengkiettisak', y: 0.23, percentage: 0.23, color: '#BA55D3', shares: 5568300 },
        { name: 'Other shareholders', y: 27.42, percentage: 27.42, color: '#8A2BE2', shares: 673035146 },
        { name: 'Total Shares', y: 100, percentage: 100, color: '#8A2BE2', shares: 2454122453 }
      ]

    };
  },
  computed: {
    chartData() {
      return this.$i18n.locale === 'en' ? this.shareholderDataEn : this.shareholderDataTh;
    },
    tableData() {
      return this.$i18n.locale === 'en' ? this.shareholderTableEn : this.shareholderTableTh;
    }
  },
  watch: {
    '$i18n.locale'() {
      this.renderChart();
    }
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      Highcharts.chart(this.$refs.donutChart, {
        chart: {
          type: 'pie'
        },
        title: {
          text: ''
        },
        tooltip: {
          formatter: function () {
            console.log(this.point.name);
            return `<p>${this.point.name}</p><br/><b>${this.point.y}%</b><br/><b>Shares:</b> ${Highcharts.numberFormat(this.point.shares, 0, '.', ',')}`;
          }
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            dataLabels: {
              enabled: true,
              format: '{point.y} %'
            }
          }
        },
        series: [{
          name: '',
          data: this.chartData.map(item => ({
            name: item.name,
            y: item.y,
            color: item.color,
            shares: item.shares  // ตรวจสอบให้แน่ใจว่าเป็น number
          }))
        }],
        credits: { enabled: false }
      });


      // Highcharts.chart(this.$refs.donutChart, {
      //   chart: {
      //     type: 'pie'
      //   },
      //   title: {
      //     text: ''
      //   },
      //   plotOptions: {
      //     pie: {
      //       innerSize: '60%',
      //       dataLabels: {
      //         enabled: true,
      //         format: '{point.y} %'
      //       }
      //     }
      //   },
      //   series: [{
      //     data: this.chartData.map(item => ({
      //       name: item.name,
      //       y: item.y,
      //       color: item.color
      //     }))
      //   }],
      //   credits: { enabled: false }
      // });
    }
  }
};
</script>


<style scoped>
.donut-chart-container {
  width: 100%;
  max-width: 500px;
  height: 400px;
  margin: 0 auto;
}

.shareholder-list {
  list-style-type: none;
  padding: 0;
}

.shareholder-list li {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}

.color-circle {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}
</style>
